import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: [
    'M4 6.5c0 .276-.224.5-.5.5S3 6.776 3 6.5s.224-.5.5-.5.5.224.5.5zM12.5 6h-6c-.28 0-.5.22-.5.5 0 .27.22.5.5.5h6c.28 0 .5-.23.5-.5 0-.28-.22-.5-.5-.5zM4 9.5c0 .276-.224.5-.5.5S3 9.776 3 9.5s.224-.5.5-.5.5.224.5.5zM12.5 9h-6c-.28 0-.5.22-.5.5 0 .27.22.5.5.5h6c.28 0 .5-.23.5-.5 0-.28-.22-.5-.5-.5zM4 12.5c0 .276-.224.5-.5.5s-.5-.224-.5-.5.224-.5.5-.5.5.224.5.5zM12.5 12h-6c-.28 0-.5.22-.5.5 0 .27.22.5.5.5h6c.28 0 .5-.23.5-.5 0-.28-.22-.5-.5-.5z',
    'M16 15V2c0-1.1-.9-2-2-2H2C.9 0 0 .9 0 2v13c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2zM2 1h12c.55 0 1 .45 1 1v1H1V2c0-.55.45-1 1-1zM1 15V4h14v11c0 .55-.45 1-1 1H2c-.55 0-1-.45-1-1z',
    'M18.37 3.16c-.18-.2-.49-.22-.69-.04s-.23.49-.05.69c.25.28.37.63.37.99v12.75c0 .81-.63 1.45-1.44 1.45H5.82c-.37 0-.73-.13-1-.39-.2-.19-.5-.17-.69.03-.18.2-.18.51.02.7.46.42 1.05.66 1.67.66h10.74c1.35 0 2.44-1.1 2.44-2.45V4.8c0-.6-.22-1.19-.63-1.64z',
  ],
  height: 20,
  width: 20,
});
